module.exports = __webpack_public_path__ + "img/pumas-brand-header.bf2b3e75.svg";